<template>
	<div>
		<ErrandOrderSendCard
			v-if="is_errand_send"
			:order="order"
			@refresh="refreshData"
		></ErrandOrderSendCard>

		<ErrandOrderBuyCard v-else-if="is_errand_buy" :order="order" @refresh="refreshData">
		</ErrandOrderBuyCard>
	</div>
</template>

<script>
import { fromUnixToDateTimeFilter, moneyFilter } from '@/util/filter'
import ErrandOrderSendCard from './util/ErrandOrderSendCard'
import ErrandOrderBuyCard from './util/ErrandOrderBuyCard'
export default {
	name: 'ErrandOrderCard',
	props: ['order', 'index'],
	filters: {
		fromUnixToDateTimeFilter,
		moneyFilter
	},
	components: {
		ErrandOrderSendCard,
		ErrandOrderBuyCard
	},
	methods: {
		refreshData: function () {
			this.$emit('refresh')
		}
	},
	computed: {
		is_errand_buy: function () {
			return this.order && !!this.order.order_id
		},
		is_errand_send: function () {
			return this.order && !!this.order.o2o_errand_order_id
		}
	}
}
</script>
